"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenu = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var icon_1 = require("../icon");
var use_default_1 = require("../_util/use-default");
var config_context_1 = require("../_util/config-context");
var MenuContext_1 = require("./MenuContext");
var MenuItem_1 = require("./MenuItem");
var is_child_of_type_1 = require("../_util/is-child-of-type");
function hasSelectedItem(children) {
    var hasSelected = false;
    react_1.default.Children.forEach(children, function (child) {
        if (is_child_of_type_1.isChildOfType(child, MenuItem_1.MenuItem) && child.props.selected) {
            hasSelected = true;
        }
    });
    return hasSelected;
}
exports.SubMenu = react_1.forwardRef(function SubMenu(props, ref) {
    var _a;
    var defaultDefaultOpened = react_1.useMemo(function () { return hasSelectedItem(props.children); }, [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    var title = props.title, icon = props.icon, children = props.children, _b = props.defaultOpened, defaultOpened = _b === void 0 ? defaultDefaultOpened : _b, _opened = props.opened, _onOpenedChange = props.onOpenedChange, className = props.className, restProps = tslib_1.__rest(props, ["title", "icon", "children", "defaultOpened", "opened", "onOpenedChange", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    // 包含 tag 的子菜单项
    var _c = tslib_1.__read(react_1.useState([]), 2), tags = _c[0], setTags = _c[1];
    // 子菜单被选中项
    var _d = tslib_1.__read(react_1.useState(null), 2), selectedId = _d[0], setSelectedId = _d[1];
    var collapsed = react_1.useContext(MenuContext_1.MenuContext).collapsed;
    // eslint-disable-next-line no-param-reassign
    var _e = tslib_1.__read(use_default_1.useDefault(_opened, defaultOpened, _onOpenedChange), 2), opened = _e[0], onOpenedChange = _e[1];
    var _f = tslib_1.__read(Array.isArray(icon) ? icon : [icon, icon], 2), defaultIcon = _f[0], activeIcon = _f[1];
    return (react_1.default.createElement("li", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-menu__submenu", className, (_a = {},
            _a[classPrefix + "-menu__subbadge"] = tags.length && !opened,
            _a["is-selected"] = !!selectedId && (collapsed || !opened),
            _a["is-expanded"] = opened,
            _a)) }, restProps),
        react_1.default.createElement("a", { className: classPrefix + "-menu__item", onClick: function () { return onOpenedChange(!opened); } },
            defaultIcon &&
                (typeof defaultIcon === "string" ? (react_1.default.createElement("img", { className: classPrefix + "-menu__list-icon", src: defaultIcon, alt: "icon" })) : (defaultIcon)),
            activeIcon &&
                (typeof activeIcon === "string" ? (react_1.default.createElement("img", { className: classPrefix + "-menu__list-icon is-selected", src: activeIcon, alt: "icon" })) : (activeIcon)),
            react_1.default.createElement("div", { className: classPrefix + "-menu__text" }, title),
            react_1.default.createElement(icon_1.Icon, { type: "arrowdown" })),
        react_1.default.createElement("ul", { className: classPrefix + "-menu__list" },
            react_1.default.createElement(MenuContext_1.SubMenuContext.Provider, { value: {
                    inSubMenu: true,
                    onTagChange: function (id, hasTag) {
                        return setTags(function (tags) {
                            if (hasTag) {
                                return tslib_1.__spread(tags, [id]);
                            }
                            return tags.filter(function (i) { return i !== id; });
                        });
                    },
                    onSelectedChange: function (id, selected) {
                        return setSelectedId(function (selectedId) {
                            if (selected) {
                                return id;
                            }
                            if (id === selectedId) {
                                return null;
                            }
                            return selectedId;
                        });
                    },
                } }, children))));
});
exports.SubMenu.displayName = "SubMenu";
//# sourceMappingURL=SubMenu.js.map